import { render, staticRenderFns } from "./SSOLogin.vue?vue&type=template&id=fb11bf0c&scoped=true"
import script from "./SSOLogin.vue?vue&type=script&lang=js"
export * from "./SSOLogin.vue?vue&type=script&lang=js"
import style0 from "./SSOLogin.vue?vue&type=style&index=0&id=fb11bf0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb11bf0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb11bf0c')) {
      api.createRecord('fb11bf0c', component.options)
    } else {
      api.reload('fb11bf0c', component.options)
    }
    module.hot.accept("./SSOLogin.vue?vue&type=template&id=fb11bf0c&scoped=true", function () {
      api.rerender('fb11bf0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/front/SSOLogin.vue"
export default component.exports